export const colorBrandObject = {
    loginPageImageUrl: "/assets/coverimage.svg",
    mainKpiColor: "rgb(64, 62, 159)",
    firstKpiColor: "#F6FAFE",
    secondKpiColor: "#F6FAFE",
    thirdKpiColor: "#F6FAFE",
    primaryButtonColor: "rgb(64, 62, 159)",
    primaryButtonColor2: "#E4E3FF",

    secondaryButtonColor: "rgb(36, 183, 170)",
    lineGraphColor: "#4F4DC3",
    barGraphColor: "#ADABE4",
    tableHeader: "#cac9fb",
    sideBarSelectedOptionBackground: "#24b7aa",
    sideBarSelectedOptionColor: "#ffff",
    platformLogoUrl: "/assets/boxpayLogo.svg",
    loginPageImageBackgroundColor: "rgba(34, 40, 226, 1)",
    actionIconColor: "#474B55",
    primary: "rgb(64, 62, 159)",
    secondary: "rgb(36, 183, 170)"
} 